import { observer } from "mobx-react-lite";
import { Checkbox } from "primereact/checkbox";
import * as React from "react";
import { CvpButton } from "../../generic-components/buttons/CvpButton";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { useStorageBackedState } from "../../utils/useStorageBackedState";

export interface AdminProps {
  showVpnTools: boolean;
  setShowVpnTools: (showVpnTools: boolean) => void;
  enableParameterOverrides: boolean;
  setEnableParameterOverrides: (enableParameterOverrides: boolean) => void;
}
export const AdminContext = React.createContext<AdminProps>(null);

export const AdminProvider = ({ children }: { children: React.ReactNode }) => {
  const [_showVpnTools, setShowVpnTools] = useStorageBackedState<boolean>(
    "showVpnTools",
    false
  );

  const [enableParameterOverrides, setEnableParameterOverrides] =
    useStorageBackedState<boolean>("enableParameterOverrides", false);

  const showVpnTools = !!window.isLocalIp && _showVpnTools;

  const value = {
    showVpnTools,
    setShowVpnTools,
    enableParameterOverrides: showVpnTools && enableParameterOverrides,
    setEnableParameterOverrides,
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};

export function useEnableParameterOverrides() {
  return React.useContext(AdminContext).enableParameterOverrides;
}

export function useShowVpnTools() {
  return React.useContext(AdminContext).showVpnTools;
}

export interface VpnToolsToggleButtonProps {
  onDeactivate?: () => void;
}
export const VpnToolsToggleButton = observer((props: VpnToolsToggleButtonProps) => {
  const { onDeactivate } = props;
  const L = useLocStore(LocContext.PROFILE);
  const showVpnTools = useShowVpnTools();
  const adminContext = React.useContext(AdminContext);

  return (
    <CvpButton
      className="vpn-item"
      iconPos="left"
      icon={showVpnTools ? "pi pi-fw pi-check-circle" : "pi pi-fw pi-circle"}
      label={L.id("eecdfc53291b").loc("Vis VPN verktøy")}
      onClick={(evt) => {
        const newValue = !showVpnTools;

        adminContext.setShowVpnTools(newValue);
        if (!newValue && onDeactivate) {
          onDeactivate();
        }
      }}
      outlined
    />
  );
});

export const ParameterOverrideToggleButton = observer(() => {
  const L = useLocStore(LocContext.PROFILE);
  const enableParameterOverrides = useEnableParameterOverrides();
  const adminContext = React.useContext(AdminContext);
  const inputId = "parameter-override-toggle";

  return (
    <label
      htmlFor={inputId}
      style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}
    >
      <Checkbox
        inputId={inputId}
        checked={enableParameterOverrides}
        onChange={(e) => adminContext.setEnableParameterOverrides(!!e.checked)}
      />
      {L.id("po4f8a1c2b73").loc("Overtsyr parametre etter innlogging")}
    </label>
  );
});
